export const apiKey = 'AIzaSyC3jRTroG3EkcFla_kRx0nrr3Y7L9hLIRw';
